import { gql } from '__generated__'

/**
 * Reports a batch of frontend events, at most 50 (FE-321). The backend
 * answers `true` even for events it drops (unknown name, props over 4 KB,
 * rate limit); one invalid field fails the whole call.
 */
export const TRACK_EVENTS = gql(`
  mutation trackEvents($events: [TrackEventInput!]!) {
    trackEvents(events: $events)
  }
`)
